const CalcData = [
  [
    { className: 'btn light-gray', name: 'AC' },
    { className: 'btn light-gray', name: '+/-' },
    { className: 'btn light-gray', name: '%' },
    { className: 'btn bg-orange', name: '÷' },
  ],
  [
    { className: 'btn light-gray', name: '7' },
    { className: 'btn light-gray', name: '8' },
    { className: 'btn light-gray', name: '9' },
    { className: 'btn bg-orange', name: 'x' },
  ],
  [
    { className: 'btn light-gray', name: '4' },
    { className: 'btn light-gray', name: '5' },
    { className: 'btn light-gray', name: '6' },
    { className: 'btn bg-orange', name: '-' },
  ],
  [
    { className: 'btn light-gray', name: '1' },
    { className: 'btn light-gray', name: '2' },
    { className: 'btn light-gray', name: '3' },
    { className: 'btn bg-orange', name: '+' },
  ],
  [
    { className: 'btn light-gray btn-0', name: '0' },
    { className: 'btn light-gray', name: '.' },
    { className: 'btn bg-orange', name: '=' },
  ],
];

export default CalcData;
